// Quem é esta conta para a tela de Assinatura.
//
// `resolverPerfilDeAcesso` é o de src/utils/entitlements.js (espelho do
// servidor): ({subscriptionInfo, criador, parceiro: USER.PARCEIRO})
//   → {tier, tierUser, tierParceiro, beneficios}
//   tierUser     'GRATUITO' | 'PREMIUM' | 'CRIADOR'        (o que a PESSOA tem)
//   tierParceiro null | 'VINCULADO' | 'VINCULADO_PREMIUM'  (USER.PARCEIRO.TIER)

export { resolverPerfilDeAcesso } from '../../utils/entitlements';

/**
 * O que a tela de Assinatura mostra para esta conta.
 *   'pagante'   assinatura própria (loja ou site): status + gerenciar
 *   'criador'   Premium do programa Criadores Parceiros
 *   'academia'  Premium pago pela academia (tierParceiro VINCULADO_PREMIUM)
 *   'gratis'    nada disso: o funil (Comparativo → Lembrete → Planos)
 *
 * O "Premium de parceiro" antigo em SUBSCRIPTION_INFO NÃO conta (30/09/2026):
 * quem só tinha ele é grátis/essencial e vê o funil. Só a academia marcada
 * como Premium dos alunos (USER.PARCEIRO.TIER) dá o modo 'academia'.
 * @param {{tierUser?:string, tierParceiro?:?string}} perfil de resolverPerfilDeAcesso
 * @return {'pagante'|'criador'|'academia'|'gratis'}
 */
export function modoDaAssinatura(perfil) {
  if (perfil?.tierUser === 'CRIADOR') return 'criador';
  if (perfil?.tierUser === 'PREMIUM') return 'pagante';
  if (perfil?.tierParceiro === 'VINCULADO_PREMIUM') return 'academia';
  return 'gratis';
}
